var _module = require('../module');
var _ = require('lodash');
var moment = require('moment');

require('../../services/lr-touch');
require('../../services/user');
require('../../services/realtime');
require('../../services/verify-modal');
require('../../services/feed-utils');
require('../../services/fullscreen-loading');
require('../../services/search-results-utils');
require('../../filters');

require('../third-party/angular-infinite-scroll');

_module.requires.push('infinite-scroll');

_module.component('listingActivityFeed', {
    controllerAs: 'laf',
    controller: [
        '$log',
        '$scope',
        '$timeout',
        '$state',
        '$stateParams',
        '$rootScope',
        '$user',
        'srUtils',
        'feedUtils',
        '$window',
        '$fsloading',
        'realTime',
        '$location',

        function listingActivityFeedCtrl($log, $scope, $timeout, $state, $stateParams, $rootScope, $user, srUtils, feedUtils, $window, $fsloading, realTime, $location) {
            var _this = this;

            var initShowType = function () {
                var showType = {
                    options:[
                        {value: 'all', title: 'Show All'},
                        {value: 'favorites', title: 'Show My Favorites'},
                        {value: 'just_listed', title: 'Show Just Listed'},
                        {value: 'recently_sold', title: 'Show Recently Sold'}
                    ]
                };

                if($stateParams.showType &&
                    ['all', 'favorites', 'just_listed', 'recently_sold'].indexOf($stateParams.showType) > -1) {
                    showType.selectedVal = $stateParams.showType;
                }else {
                    showType.selectedVal = 'all';
                }

                _this.showType = showType;
            };

            var initUiFlags = function () {
                _this.ui = {
                    loadingChangelog: false,
                    newChangelogCount: 0
                };
            };

            var initPageData = function () {
                _this.pageData = {
                    listingsChangelog: {
                        lastId: null,
                        lastCreatedAt: null,
                        perPage: 20,
                        lastFetchCount: 0,
                        hasMore: true
                    },
                    recentlySold: {
                        pageNum: 1,
                        perPage: 20,
                        lastFetchCount: 0,
                        hasMore: true
                    }
                };
            };

            var updatePageData = function (changelog, feedType, fetchCount) {
                if(feedType === 'listings_changelog') {
                    _this.pageData.listingsChangelog.lastFetchCount = fetchCount;
                    _this.pageData.listingsChangelog.lastId = changelog[changelog.length - 1]['id'];
                    _this.pageData.listingsChangelog.lastCreatedAt = changelog[changelog.length - 1]['createdAt'];
                    _this.pageData.listingsChangelog.hasMore = (_this.pageData.listingsChangelog.lastFetchCount === _this.pageData.listingsChangelog.perPage);
                }else if (feedType === 'recently_sold') {
                    _this.pageData.recentlySold.pageNum += 1;
                    _this.pageData.recentlySold.lastFetchCount = fetchCount;
                    _this.pageData.recentlySold.hasMore = (_this.pageData.recentlySold.lastFetchCount === _this.pageData.recentlySold.perPage);
                }
            };

            var updateChangelog = function (changelog, feedType, incrementPage, groupByKey) {
                var oldChangelog = _this.changelog;

                if(changelog && angular.isArray(changelog)) {

                    if(changelog.length > 0){
                        if(incrementPage){
                            updatePageData(changelog, feedType, changelog.length);
                        }

                        var newChangelog = feedUtils.processChangelog(changelog, oldChangelog, groupByKey);
                        _this.changelog = newChangelog;
                    }else {
                        if(feedType === 'listings_changelog') {
                            _this.pageData.listingsChangelog.lastFetchCount = 0;
                            _this.pageData.listingsChangelog.hasMore = false;
                        }

                        if(feedType === 'recently_sold') {
                            _this.pageData.recentlySold.lastFetchCount = 0;
                            _this.pageData.recentlySold.hasMore = false;
                        }
                    }
                }
            };

            var fetchListingChangelog = function (showFsLoader, nextPage) {
                if(showFsLoader) {
                    $fsloading.show();
                }
                _this.ui.loadingChangelog = true;

                var lastId = (nextPage)? _this.pageData.listingsChangelog.lastId : null;
                var lastCreatedAt = (nextPage)? _this.pageData.listingsChangelog.lastCreatedAt : null;

                feedUtils.getListingChangelog(lastId, lastCreatedAt)
                    .then(function (response) {
                        if(response && response.data && response.data.data) {
                            updateChangelog(response.data.data, 'listings_changelog', nextPage);
                        }else{
                            $log.debug('Error getting changelog!', response);
                        }
                    })
                    .catch(function (err) {
                        $log.error('Error getting changelog!', err);
                    })
                    .finally(function () {
                        _this.ui.loadingChangelog = false;
                        $fsloading.hide();

                        if(!nextPage) {
                            // fetched new changelogs so we
                            // reset unread count
                            _this.ui.newChangelogCount = 0;
                        }
                    });
            };

            var getISODate = function (str) {
                var iso_date = null;
                if(str && str.length > 0) {
                    iso_date = moment(str, 'YYYY-M-DD').toISOString();
                }
                return iso_date;
            };

            var fetchRecentlySoldLog = function (showFsLoader) {
                if(showFsLoader){
                    $fsloading.show();
                }
                _this.ui.loadingRecentlySoldLog = true;

                var pageNum = !isNaN(_this.pageData.recentlySold.pageNum)
                    ? parseInt(_this.pageData.recentlySold.pageNum, 10)
                    : 1;

                feedUtils.getRecentlySoldLog(pageNum)
                    .then(function (response) {
                        if(response && _.has(response, 'data.data.listings')) {
                            var rsl = response.data.data.listings.map(function (res) {
                                return _.extend({}, res, {
                                    type: 'sold',
                                    sale_date_iso: getISODate(res.sale_date)
                                });
                            });
                            updateChangelog(rsl, 'recently_sold', true, 'sale_date');
                        }else{
                            $log.debug('Error getting recently sold log!', response);
                        }
                    })
                    .catch(function (err) {
                        $log.error('Error getting recently sold log!', err);
                    })
                    .finally(function () {
                        _this.ui.loadingRecentlySoldLog = false;
                        $fsloading.hide();
                    });
            };

            var incrementNewChangelogCount = function () {
                if(_this.ui && !isNaN(_this.ui.newChangelogCount)) {
                    _this.ui.newChangelogCount += 1;
                }
            };

            var initAuthQueryParamCheck = function () {
                if($location.search() && $location.search().a && $user.account_type !== 'guest') {
                    $state.go('.', {a: undefined});
                }
            };

            var init = function () {
                _this.usr = $user;
                _this.isMobile = srUtils.isMobile();
                _this.changelog = [];
                initUiFlags();
                initPageData();
                initShowType();
                initAuthQueryParamCheck();
                fetchListingChangelog(true, true);
                fetchRecentlySoldLog(true);
            };

            init();

            // Public Functions

            _this.hasMoreChangelogs = function () {
                return _this.pageData && _this.pageData.listingsChangelog && _this.pageData.listingsChangelog.hasMore;
            };

            _this.hasMoreRecentlySoldLogs = function () {
               return _this.pageData && _this.pageData.recentlySold && _this.pageData.recentlySold.hasMore;
            };

            _this.fetchLatestChangelogs = function () {
                $log.debug('fetching latest changelogs...', _this.pageData);
                fetchListingChangelog(false, false);
            };

            _this.fetchOlderPosts = function () {
                if(_this.hasMoreChangelogs()){
                    $log.debug('fetching more listing changelogs...', _this.pageData.listingsChangelog);
                    fetchListingChangelog(false, true);
                }

                if(_this.hasMoreRecentlySoldLogs()){
                    $log.debug('fetching more recently sold logs...', _this.pageData.recentlySold);
                    fetchRecentlySoldLog(false);
                }
            };

            /// REALTIME HANDLERS

            realTime.on('user-listing-changelog-inserted', function (data) {
                if(feedUtils.isFeedCandidate(data)) {
                    incrementNewChangelogCount();
                    $log.debug('User Listing Changelog Inserted', data);
                }
            });

        }
    ],
    template: require('./index.html')
});
